module.exports = __webpack_public_path__ + "static/img/wufuleirong_03.2aaedea1.jpg";